// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticlePage_container__zKboU"};